document.addEventListener('DOMContentLoaded', function () {
  const isTaxIncluded = window.taxSettings.isTaxIncluded
  const taxLabelText = window.taxSettings.taxLabelText


  if (window.location.pathname.includes('products') && isTaxIncluded) {
    var priceElements = document.querySelectorAll('.pr-price');
    priceElements.forEach(function (priceElement) {
      if (!priceElement.querySelector('.price__tax-label')) {
        var taxLabel = document.createElement('span');
        taxLabel.className = 'price__tax-label';
        taxLabel.textContent = taxLabelText;
        taxLabel.style.color = '#000';
        priceElement.appendChild(taxLabel);
      }
    });
  }
});
